module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_atlas_banner_2018-caf9fc5d2d1c25de2aaf49bcd30b4e32.png";